export type TimeWindow = 'business' | 'shoulder' | 'after-hours';

export interface BusinessHoursConfig {
  timezone: string;
  shoulderStartHour: number;
  businessStartHour: number;
  businessEndHour: number;
  shoulderEndHour: number;
  /** Day-of-week indexes (0=Sunday, 6=Saturday) considered work days. */
  workDays: number[];
}

export interface TimeWindowResult {
  window: TimeWindow;
  isAfterHours: boolean;
  reason?: string;
}

/**
 * Default business-hours window — used by `resolveTimeWindow` when no
 * config is supplied AND the app-settings cache hasn't populated yet
 * (cold start, or pre-migration tenants with no `businessHours` saved).
 *
 * Sydney 9–17 business, 7–18 shoulder, Mon–Fri.
 */
export const BUSINESS_HOURS_DEFAULT: BusinessHoursConfig = {
  timezone: 'Australia/Sydney',
  shoulderStartHour: 7,
  businessStartHour: 9,
  businessEndHour: 17,
  shoulderEndHour: 18,
  workDays: [1, 2, 3, 4, 5],
};
